//@ts-ignore
import de from './translations/de.yaml';
//@ts-ignore
import en from './translations/en.yaml';

export { de, en };
